module.exports = __webpack_public_path__ + "img/arrow-down.eb71aded.svg";